module.exports = __webpack_public_path__ + "img/orange-square-table-2.5b96ea18.png";